import { DropdownButtonType, List, SingleSelectDropdown } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../gen-src/Localize';
import { inputSection } from '../configurationStyles';

export interface ComparisonTypeComponentProps {
  testId: string;
  selectedComparisonType: ComparisonType;
  canAuthorHistoricalComparison?: boolean;
  onComparisonChange: (comparisonType: ComparisonType) => void;
  disabled?: boolean;
  dropdownRef?: React.RefObject<HTMLButtonElement>;
}

/**
 * This should be in the engine's models, right?
 */
export enum ComparisonType {
  HISTORICAL = 'HISTORICAL',
  CONSTANT = 'CONSTANT',
}

const isComparisonType = (input: string): input is ComparisonType => {
  return Object.keys(ComparisonType).indexOf(input) !== -1;
};

export const ComparisonTypeDropdownComponent = (props: ComparisonTypeComponentProps): JSX.Element => {
  const listItems = [
    {
      content: historicalComparisonDisplayText(props.canAuthorHistoricalComparison ?? false),
      value: ComparisonType.HISTORICAL,
    },
    {
      content: Messages.ConstantComparison(),
      value: ComparisonType.CONSTANT,
    },
  ];

  const handleChange = (type: string) => {
    if (type !== props.selectedComparisonType) {
      if (isComparisonType(type)) {
        props.onComparisonChange(type);
      }
    }
  };

  return (
    <SingleSelectDropdown
      className={inputSection}
      testId={props.testId}
      type={DropdownButtonType.Outline}
      label={Messages.ComparisonTypeLabel()}
      list={<List items={listItems} />}
      onChange={handleChange}
      value={props.selectedComparisonType}
      disabled={props.disabled}
      buttonRef={props.dropdownRef}
    />
  );
};

// TFS1349399: For metrics without a date dimension (and without snapshotting), it's an odd
// experience to choose "Historical" and not have any other inputs or any reason why. We've
// chosen to change the label for this option but NOT persist things differently.
function historicalComparisonDisplayText(canAuthorHistoricalComparison: boolean): string {
  return canAuthorHistoricalComparison ? Messages.HistoricalComparison() : Messages.NoComparison();
}
